import { render, staticRenderFns } from "./AppNoContent.vue?vue&type=template&id=54a55839&scoped=true&"
import script from "./AppNoContent.vue?vue&type=script&lang=js&"
export * from "./AppNoContent.vue?vue&type=script&lang=js&"
import style0 from "./AppNoContent.vue?vue&type=style&index=0&id=54a55839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a55839",
  null
  
)

export default component.exports